import { render, staticRenderFns } from "./ReusableComponent.vue?vue&type=template&id=522cea0e"
import script from "./ReusableComponent.vue?vue&type=script&lang=js"
export * from "./ReusableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports